import { useEffect, useState } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useCalendly } from './useCalendly';
import logo from './assets/images/vairo-logo-full-dark.png';
import logoWhite from './assets/images/vairo-logo-full-white.png';

function Layout() {
  const isMobile = () => window.innerWidth <= 768;
  const [scrolled, setScrolled] = useState(isMobile);
  const { openCalendly, CalendlyModal } = useCalendly();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    const update = () => setScrolled(isMobile() || window.scrollY > 10);
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, []);

  const handleCompanyClick = (e) => {
    e.preventDefault();
    if (location.pathname === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate('/');
    }
  };

  return (
    <div className="page">
      <nav className={`nav${scrolled ? ' nav--scrolled' : ''}`}>
        <div className="nav-bar">
          <div className="nav-inner">
            <Link to="/">
              <img src={logo} alt="Vairo" className="nav-logo" />
            </Link>
            <div className="nav-right">
              <button className="btn-demo" onClick={openCalendly}>Demo</button>
              <a
                href="https://app.vairo.ai"
                className="nav-login"
                target="_blank"
                rel="noopener noreferrer"
              >
                Login
              </a>
            </div>
          </div>
        </div>
      </nav>

      <Outlet context={{ openCalendly }} />

      <footer className="footer">
        <div className="container footer-inner">
          <div className="footer-left">
            <img src={logoWhite} alt="Vairo" className="footer-logo" />
            <a href="mailto:hello@vairo.ai" className="footer-email">
              hello@vairo.ai
            </a>
          </div>

          <div className="footer-links">
            <a href="https://app.vairo.ai" className="footer-link" target="_blank" rel="noopener noreferrer">
              Product
            </a>
            <a href="/" className="footer-link" onClick={handleCompanyClick}>
              Company
            </a>
            <Link to="/eula" className="footer-link">EULA</Link>
            <Link to="/privacy" className="footer-link">Privacy Policy</Link>
          </div>

          <div className="footer-bottom">
            <span className="footer-copy">&copy; 2026 Vairo, Inc.</span>
          </div>
        </div>
      </footer>

      <CalendlyModal />
    </div>
  );
}

export default Layout;
